// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel[data-v-656af1ef]{height:60px;overflow:hidden}.carousel .list.animation[data-v-656af1ef]{transition:all .5s linear}.carousel .list .item[data-v-656af1ef]{box-sizing:border-box;display:flex;align-items:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:22px;padding:2px 10px;margin-bottom:4px;font-size:12px;color:#333;background:#f5f6fa;border-radius:11px;opacity:.6}", ""]);
// Exports
module.exports = exports;
